export const SOCIAL_LOGIN_URLS = {
  facebook: `${process.env.SSO_BASE_URL}/${process.env.SSO_SOCIAL_AUTH}/facebook/?next=${process.env.BASE_APP_URL}${process.env.SSO_OAUTH_REDIRECT}`,
  google: `${process.env.SSO_BASE_URL}/${process.env.SSO_SOCIAL_AUTH}/google-oauth2/?next=${process.env.BASE_APP_URL}${process.env.SSO_OAUTH_REDIRECT}`,
  linkedin: `${process.env.SSO_BASE_URL}/${process.env.SSO_SOCIAL_AUTH}/linkedin-oauth2/?next=${process.env.BASE_APP_URL}${process.env.SSO_OAUTH_REDIRECT}`
}

export const AUTH_URLS = {
  passwordReset: `${process.env.SSO_BASE_URL}/${process.env.SSO_PASSWORD_RESET}`
}



// WEBPACK FOOTER //
// ./src/components/login/utils/constants.js